import { useContext, useState, useEffect } from 'react';
import { ThemeContext } from '../../../../apps/frontend/src/context/ThemeStore';
import LoadingState from './LoadingState';
import QuestionAttempt from './QuestionAttempt';

const AttemptSimilarQsModal = ({ loading, data, onClose, packId, testId, checkSimilarQuestionsButton }) => {
  const { isDarkTheme } = useContext(ThemeContext);
  const [attemptedQuestions, setAttemptedQuestions] = useState([]);
  const [cachedData, setCachedData] = useState(null);
  const [isUsingCachedData, setIsUsingCachedData] = useState(false);

  // Cache the data when it's available
  useEffect(() => {
    if (data && !loading) {
      setCachedData(data);
      setIsUsingCachedData(false);
    }
  }, [data, loading]);

  // Check if we have cached data when loading starts
  useEffect(() => {
    if (loading && cachedData) {
      // We have cached data and new data is loading
      // Use the cached data instead of showing loading state
      setIsUsingCachedData(true);
    }
  }, [loading, cachedData]);

  const handleQuestionAttempted = (questionId) => {
    setAttemptedQuestions((prev) => {
      if (prev.includes(questionId)) return prev;
      return [...prev, questionId];
    });
  };

  // ✅ Remove immediate modal close here - WellDone will handle the final close
  const handleAllQuestionsAttempted = () => {
    // Do NOT call onClose() here — wait until user closes WellDone inside QuestionAttempt
  };

  return (
    <div
      className="fixed inset-0 z-[99999] flex items-center justify-center backdrop-blur-md bg-[rgba(16,24,40,0.70)]"
      onClick={onClose}
    >
      <div
        className="w-full max-w-md md:max-w-3xl md:h-auto p-4 flex justify-center"
        onClick={(e) => e.stopPropagation()}
      >
        {loading && !isUsingCachedData ? (
          <LoadingState />
        ) : data || cachedData ? (
          <QuestionAttempt
            data={data || cachedData}
            onClose={onClose}
            packId={packId}
            testId={testId}
            onQuestionAttempted={handleQuestionAttempted}
            onAllQuestionsAttempted={handleAllQuestionsAttempted}
            attemptedQuestions={attemptedQuestions}
            checkSimilarQuestionsButton={checkSimilarQuestionsButton}
          />
        ) : null}
      </div>
    </div>
  );
};

export default AttemptSimilarQsModal;
